module.exports = __webpack_public_path__ + "static/britishAmericanTobacco-c072407e9be8066aeb88ae6f44a5146c.png";